PageApp.Views.CreateAccountSuccessView = Backbone.Marionette.ItemView.extend({
  template: hbs.templates.createAccountSuccess
})
